var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"calculator"}},[_c('div',{staticClass:"calculator-box"},[(!_vm.$store.state.loadedValues)?_c('calculator-form'):_c('calculator-table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }